import React, { FC } from 'react';

import Color from 'color';

interface Props {
    size?: number;
    color?: string;
}

const Marker: FC<Props> = ({ size, color = '#1B2C50' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || 24}
            height={size || 24}
            viewBox="0 0 128 128">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <circle fill={color} cx="64" cy="64" r="64" />
                    <g
                        transform="translate(32.000000, 24.382450)"
                        fillRule="nonzero"
                        fill={Color(color).isLight() ? '#111111' : '#FFFFFF'}>
                        <path d="M32.021582,0 C14.1809863,0 0,13.6300052 0,30.7774312 C0,57.1580865 32.021582,87.9355177 32.021582,87.9355177 C32.021582,87.9355177 64.0431641,56.7184089 64.0431641,30.7774312 C64.0431641,13.6300052 49.8621777,0 32.021582,0 Z M32.5,50 C21.58,50 13,41.42 13,30.5 C13,19.58 21.58,11 32.5,11 C43.42,11 52,19.58 52,30.5 C52,41.42 43.42,50 32.5,50 Z" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Marker;
